import React, { PropTypes } from 'react';
import Select from 'react-select';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import { PanelStyle } from '../../constants';
import s from './CheckableDecision.scss';

import withStyles from 'isomorphic-style-loader/lib/withStyles';



class CheckableDecision extends React.Component {
  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  state = {
    tag: 'input',
  };

  render() {
    const {
      leftCol,
      labelCol,
      inputCol,
      inputStyle,
      errorSpanStyle,
      rightCol,
      labelStyle,
      rowStyle,
      type,
    } = PanelStyle;

    return (
      <GrayPanel title={this.props.title}>
        <div className={s.subtitle}>
          <input
            id="checkboxTextCheckbox"
            name="isDefault"
            type="checkbox"
            value={this.props.isChecked}
            checked={this.props.isChecked}
            onChange={this.props.onChangeCheckbox}
          />
          <label
            htmlFor="checkboxTextCheckbox">
              {this.props.checkboxText ? <p>&nbsp;&nbsp;{this.props.checkboxText}</p> : null}
          </label>
        </div>

        {this.props.extraCheckbox &&
          <div className={s.subtitle}>
            <input
            id="extraCheckbox"
            name="isDefault"
            type="checkbox"
            checked={this.props.extraCheckbox.isChecked}
            onChange={e => this.props.extraCheckbox.onChange(e, this.props.extraCheckbox.group, this.props.extraCheckbox.state)}
          />
            <label
              htmlFor="extraCheckbox">
                {this.props.checkboxText ? <p>&nbsp;&nbsp;{this.props.extraCheckbox.label}</p> : null}
            </label>
          </div>
        }

        {this.props.isChecked || (this.props.extraCheckbox && this.props.extraCheckbox.isChecked) ? Object.keys(this.props.formDict).map((v, i) => {
          const isEditable =
            this.props.formDict[v].editable && this.props.formDict[v].editable === true;
          const typeMap = {
            textarea: 'textarea',
            Select: 'Select',
          };

          const TagName = typeMap[this.props.formDict[v].type] || 'input';

          return (
            <div className="row mobile-row" key={i} style={rowStyle}>
              <div className={this.props.leftCol ? this.props.leftCol : leftCol} />
              <div className={this.props.labelCol ? this.props.labelCol : labelCol}>
                <label style={labelStyle}>{this.props.formDict[v].label}</label>
              </div>
              <div className={this.props.inputCol ? this.props.inputCol : inputCol}>
                {isEditable ? (
                  TagName === 'Select' ?
                    <Select
                      placeholder="Wybierz z listy..."
                      name="option"
                      value={this.props.data[v] ? this.props.data[v] : ''}
                      options={this.props.formDict[v].options}
                      clearable={false}
                      // onInputChange={this.inputAdressChange}
                      onChange={this.props.onChangeSelect}
                      style={{
                        borderColor:
                        Object.keys(this.props.errors).indexOf(v) > -1 &&
                        this.props.errors[v] !== null &&
                        this.props.errors[v].length > 0
                          ? 'red'
                          : '#ccc',
                      }}
                      onBlur={event => event.preventDefault()}
                      optionClassName="needsclick"
                      blurInputOnSelect={false}
                    />
                          :
                          <TagName
                            type={this.props.formDict[v].type ? this.props.formDict[v].type : type}
                            name={v}
                            style={{
                              ...inputStyle,
                              borderColor:
                                Object.keys(this.props.errors).indexOf(v) > -1 &&
                                this.props.errors[v] !== null &&
                                this.props.errors[v].length > 0
                                  ? 'red'
                                  : '#ccc',
                            }}
                            className="form-control"
                            value={this.props.data[v] ? this.props.data[v] : ''}
                            onChange={this.props.onChange}
                            placeholder={this.props.formDict[v].placeholder ? this.props.formDict[v].placeholder : ""}
                          />
                ) : (
                  <input
                    name={v}
                    style={{
                      ...inputStyle,
                      borderColor:
                        Object.keys(this.props.errors).indexOf(v) > -1 &&
                        this.props.errors[v] !== null &&
                        this.props.errors[v].length > 0
                          ? 'red'
                          : '#ccc',
                    }}
                    className="form-control"
                    value={this.props.data[v] ? this.props.data[v] : ''}
                    disabled
                  />
                )}

                {/* RENDER ERROS IN SPAN */}
                {Object.keys(this.props.errors).indexOf(v) > -1 &&
                this.props.errors[v] !== null &&
                this.props.errors[v].length > 0
                  ? this.props.errors[v].map((val, index) => (
                    <span key={index} style={errorSpanStyle}>
                      {val}
                    </span>
                    ))
                  : null}
              </div>
              <div className={this.props.rightCol ? this.props.rightCol : rightCol} />
            </div>
          );
        }) : null}
        {this.props.children}
      </GrayPanel>
    );
  }
}

CheckableDecision.PropTypes = {
  children: PropTypes.Object,
  rightCol: PropTypes.Object,
  labelCol: PropTypes.Object,
  leftCol: PropTypes.Object,
  explain_text: PropTypes.func,
  title: PropTypes.string,
  formDict: PropTypes.Object,
};

export default withStyles(s)(CheckableDecision);



// WEBPACK FOOTER //
// src/containers/CheckableDecision/index.jsx